import { render, staticRenderFns } from "./button-official.vue?vue&type=template&id=1704f9e6&scoped=true&"
import script from "./button-official.vue?vue&type=script&lang=js&"
export * from "./button-official.vue?vue&type=script&lang=js&"
import style0 from "./button-official.vue?vue&type=style&index=0&id=1704f9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704f9e6",
  null
  
)

export default component.exports